import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Observable, of} from 'rxjs';
import {AngularFireAuth} from "@angular/fire/compat/auth";
import {first, map, switchMap, tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(public afAuth: AngularFireAuth, private router: Router) {

  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.afAuth.user.pipe(
      map(usr => usr != null),
      switchMap(authenticated => {
        if (!authenticated)
          this.router.navigate(['/login']);
        return of(authenticated);
      })
    );
  }
}
